export default __webpack_public_path__ + "static/7-how-to-get-started-buyer-mobile-6e68e4426acf1c6a9ff938d0ad5e4b2c.jpg";